@import '../../../../app-brand/entities/entity-layer.module.less';

.collapsible-list-section-sub-header {
  width: 100%;
  background-color: @collapsable-list--content--background-color;
  overflow: auto;
  flex: 1;
  border-radius: inherit;
}
